import Vue from 'vue'
import Router from 'vue-router'
import { Role } from './constants'
import store from './store'

Vue.use(Router);

// View Components
import Login from './views/auth/login';
import PasswordRecover from './views/auth/password_recover.vue';
import PasswordRefresh from './views/auth/password_refresh.vue';
import Watches from './views/watches/index';
import Dashboard from './views/dashboard/dashboard';
import Users from './views/users/index';
import Brands from './views/brands/index';
import Orders from './views/orders/index';
import Order from './views/orders/order';
import Settings from './views/settings/index';
import Announcements from './views/announcements/index';
import Announcement from './views/announcements/announcement';
import _404 from './views/errors/404';

const AuthenticatedMiddleware = ({ next, store: { getters }, to }) => {

    const isAuthenticated = getters['session/isLogged']

    if (!isAuthenticated) {
        return next({ name: 'login' })
    }

    return next()
}

const JustGuestMiddleware = ({ next, store: { getters } }) => {

    const isAuthenticated = getters['session/isLogged']

    if (isAuthenticated) {
        return next({ name: 'announcements' })
    }

    return next()
}

const nextFactory = (context, middleware, index) => {
    const subsequentMiddleware = middleware[index]
    if (!subsequentMiddleware) {
        return context.next
    }

    return (...parameters) => {
        context.next(...parameters)
        const nextMiddleware = nextFactory(context, middleware, index + 1)
        subsequentMiddleware({ ...context, next: nextMiddleware })
    }
}

const router = new Router({
    mode: 'history',
    routes: [
        /*****************
         * AUTH ROUTES
         ****************/
        {
            path: '/',
            name: 'welcome',
            component: Login,
            // component: () => import(/* webpackChunkName: "login" */ '@/views/auth/login.vue'),
            meta: {
                title: 'login',
                excludedFromSideBar: true,
                middleware: [JustGuestMiddleware]
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            // component: () => import(/* webpackChunkName: "login" */ '@/views/auth/login.vue'),
            meta: {
                title: 'login',
                excludedFromSideBar: true,
                middleware: [JustGuestMiddleware]
            }
        },
        {
            path: '/password',
            name: 'password',
            component: PasswordRefresh,
            // component: () => import(/* webpackChunkName: "password" */ '@/views/auth/password_refresh.vue'),
            meta: {
                title: 'password_refresh',
                excludedFromSideBar: true,
                middleware: [JustGuestMiddleware]
            }
        },
        {
            path: '/recover',
            name: 'recover',
            component: PasswordRecover,
            // component: () => import(/* webpackChunkName: "recover" */ '@/views/auth/password_recover.vue'),
            meta: {
                title: 'password_recover',
                excludedFromSideBar: true,
                middleware: [JustGuestMiddleware]
            }
        },

        /******************
         * APP ROUTES
         *****************/
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            // component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/dashboard.vue'),
            meta: {
                title: 'dashboard',
                excludedFromSideBar: false,
                icon: 'line-chart',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/brands',
            name: 'brands',
            component: Brands,
            // component: () => import(/* webpackChunkName: "dashboard" */ '@/views/brands/index.vue'),
            meta: {
                title: 'brands',
                excludedFromSideBar: false,
                icon: 'skin',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/watches-list',
            name: 'listWatches',
            component: Watches,
            // component: () => import(/* webpackChunkName: "watches" */ '@/views/watches/index.vue'),
            meta: {
                title: 'watches',
                excludedFromSideBar: false,
                icon: 'clock-circle',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            // component: () => import(/* webpackChunkName: "users" */ '@/views/users/index.vue'),
            meta: {
                title: 'users',
                excludedFromSideBar: false,
                icon: 'team',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            // component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/index.vue'),
            meta: {
                title: 'orders',
                excludedFromSideBar: false,
                icon: 'profile',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/orders/:id',
            name: 'order',
            component: Order,
            // component: () => import(/* webpackChunkName: "order" */ '@/views/orders/order.vue'),
            meta: {
                title: 'order',
                excludedFromSideBar: true,
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/announcements',
            name: 'announcements',
            component: Announcements,
            // component: () => import(/* webpackChunkName: "order" */ '@/views/orders/index.vue'),
            meta: {
                title: 'announcements',
                excludedFromSideBar: false,
                icon: 'notification',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/announcements/:id',
            name: 'announcement',
            component: Announcement,
            // component: () => import(/* webpackChunkName: "order" */ '@/views/announcements/index.vue'),
            meta: {
                title: 'announcements',
                excludedFromSideBar: true,
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            // component: () => import(/* webpackChunkName: "order" */ '@/views/settings/index.vue'),
            meta: {
                title: 'settings',
                excludedFromSideBar: false,
                icon: 'setting',
                middleware: [AuthenticatedMiddleware]
            }
        },
        {
            path: '*',
            component: _404,
            // component: () => import(/* webpackChunkName: "404" */ '@/views/errors/404.vue'),
            meta: {
                title: '404',
                excludedFromSideBar: true
            }
        }
    ],
})

router.beforeEach((to, from, next) => {
    // store.dispatch('vanishErrors')
    // store.dispatch('cancelPendingRequest');
    
    if (to.meta?.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
        const context = { to, from, next, router, store }
        const nextMiddleware = nextFactory(context, middleware, 1)
        return middleware[0]({...context, next: nextMiddleware})
    }

    return next()
})

export default router